var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 229,
    viewBox: "0 0 229 229",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.48584,
    y: 0.514465,
    width: 227.774,
    height: 227.774,
    rx: 10,
    fill: "#D8D8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.373 42.2892C95.254 42.3107 76.9245 49.9151 63.4055 63.4341C49.8865 76.9531 42.2821 95.2826 42.2606 114.401C42.2931 133.517 49.9011 151.84 63.4177 165.356C76.9342 178.873 95.2574 186.481 114.373 186.513C133.498 186.513 151.84 178.916 165.364 165.392C178.887 151.869 186.485 133.527 186.485 114.401C186.485 95.276 178.887 76.934 165.364 63.4103C151.84 49.8867 133.498 42.2892 114.373 42.2892ZM158.235 156.012C154.184 147.844 147.932 140.97 140.183 136.166C132.434 131.362 123.497 128.819 114.379 128.824C105.262 128.829 96.3276 131.381 88.5838 136.194C80.84 141.006 74.5951 147.887 70.5537 156.059C59.7699 144.877 53.7609 129.936 53.7985 114.401C53.7985 98.336 60.1804 82.9287 71.5403 71.5689C82.9002 60.209 98.3074 53.8271 114.373 53.8271C130.438 53.8271 145.845 60.209 157.205 71.5689C168.565 82.9287 174.947 98.336 174.947 114.401C174.983 129.914 168.99 144.834 158.235 156.012ZM114.373 71.134C109.238 71.134 104.219 72.6566 99.9499 75.5091C95.6807 78.3617 92.3533 82.4162 90.3884 87.1598C88.4236 91.9034 87.9095 97.1232 88.9112 102.159C89.9128 107.195 92.3853 111.82 96.0159 115.451C99.6466 119.082 104.272 121.554 109.308 122.556C114.344 123.558 119.564 123.043 124.307 121.079C129.051 119.114 133.105 115.786 135.958 111.517C138.81 107.248 140.333 102.229 140.333 97.0944C140.333 93.6852 139.662 90.3094 138.357 87.1598C137.052 84.0101 135.14 81.1483 132.729 78.7376C130.319 76.327 127.457 74.4148 124.307 73.1101C121.158 71.8055 117.782 71.134 114.373 71.134Z",
    fill: "#F2EDED"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/userProfile.5990ccc72823213f5d87d8e54236f200.svg";
export { ForwardRef as ReactComponent };